import React from 'react';

const DataPrivacyPage = () => {
  return (
    <div className="container my-5">
      <h1 className="text-center mb-4">Meetvana Data Privacy Policy</h1>

      <div className="mb-4">
        <h2 className="h4">1. Introduction</h2>
        <p>
          At Meetvana, we are committed to protecting your personal data and respecting your privacy. This policy explains how we collect, use, and safeguard your information.
        </p>
      </div>

      <div className="mb-4">
        <h2 className="h4">2. Data We Collect</h2>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">Personal identification information (e.g., name, email)</li>
          <li className="list-group-item">Usage data and preferences</li>
          <li className="list-group-item">Device and browser information</li>
        </ul>
      </div>

      <div className="mb-4">
        <h2 className="h4">3. How We Use Your Data</h2>
        <p>We use your data to:</p>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">Provide and improve Meetvana services</li>
          <li className="list-group-item">Personalize your experience</li>
          <li className="list-group-item">Communicate updates and offers</li>
        </ul>
      </div>

      <div className="mb-4">
        <h2 className="h4">4. Data Sharing</h2>
        <p>
          We do not sell your personal data. We may share data with trusted third-party providers who help us operate Meetvana, under strict confidentiality agreements.
        </p>
      </div>

      <div className="mb-4">
        <h2 className="h4">5. Your Rights</h2>
        <p>
          You have the right to access, correct, or delete your personal data. You can also object to certain data processing activities.
        </p>
      </div>

      <div className="mb-4">
        <h2 className="h4">6. Contact Us</h2>
        <p>
          If you have any questions about this policy or your data, please contact us.
        </p>
      </div>
    </div>
  );
};

export default DataPrivacyPage;